import { forwardRef } from "react";
import pick from "lodash/pick";
import TextField from "@mui/material/TextField";
import NumberFormat from "../NumberFormat";

const CreditCardField = (props) => {
	const importedProps = pick(props, [
		"autoWidth",
		"children",
		"classes",
		"displayEmpty",
		"input",
		"inputProps",
		"native",
		"onChange",
		"renderValue",
		"value",
		"variant",
		"color",
		"onBlur",
		"name",
		"label",
		"className",
		"required",
		"error",
		"helperText",
		"variant",
		"fullWidth",
		"autoFocus",
	]);
	return (
		<TextField
			{...importedProps}
			inputProps={{
				format: "#### #### #### ####",
			}}
			InputProps={{
				inputComponent: NumberFormat,
			}}
		/>
	);
};

export default forwardRef((props, ref) => (
	<CreditCardField {...props} forwardRef={ref} />
));
